import { off as r, on as u } from "./highrise632.mjs";
const d = "@@coContext", a = {
  mounted(t, { value: c, modifiers: e }) {
    t[d] = {
      handler: void 0
    }, typeof c == "function" && (t[d].handler = c, u("clickoutside", t, c, {
      capture: e.capture
    }));
  },
  updated(t, { value: c, modifiers: e }) {
    const n = t[d];
    typeof c == "function" ? n.handler ? n.handler !== c && (r("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = c, u("clickoutside", t, c, {
      capture: e.capture
    })) : (t[d].handler = c, u("clickoutside", t, c, {
      capture: e.capture
    })) : n.handler && (r("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = void 0);
  },
  unmounted(t, { modifiers: c }) {
    const { handler: e } = t[d];
    e && r("clickoutside", t, e, {
      capture: c.capture
    }), t[d].handler = void 0;
  }
};
export {
  a as default
};
